import styled, { css } from "styled-components";
import { breakpoints } from "styles";

//This component takes spaces in an array, [mobileSpace, tabletSpace, laptopSpace]
//the values are as per breakpoints in the system

export enum SPACER_DIRECTION {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal"
}

type SpaceToken = [number, number, number];

const makeVerticalSpace = (token: SpaceToken) => {
  const [mobileSpaceToken, tabletSpaceToken, laptopSpaceToken] = token;
  return css`
    margin: 0 0 ${mobileSpaceToken}px 0;

    @media ${breakpoints.tablet} {
      margin: 0 0 ${tabletSpaceToken}px 0;
    }

    @media ${breakpoints.laptop} {
      margin: 0 0 ${laptopSpaceToken}px 0;
    }
  `;
};

const makeHorizontalSpace = (token: SpaceToken) => {
  const [mobileSpaceToken, tabletSpaceToken, laptopSpaceToken] = token;
  return css`
    margin: 0 0 0 ${mobileSpaceToken}px;

    @media ${breakpoints.tablet} {
      margin: 0 0 0 ${tabletSpaceToken}px;
    }

    @media ${breakpoints.laptop} {
      margin: 0 0 0 ${laptopSpaceToken}px;
    }
  `;
};

const makeSpace = (
  direction: SPACER_DIRECTION = SPACER_DIRECTION.VERTICAL,
  token: SpaceToken
) =>
  direction === SPACER_DIRECTION.VERTICAL
    ? makeVerticalSpace(token)
    : makeHorizontalSpace(token);

const Spacer = styled.div<{
  token: SpaceToken;
  direction?: SPACER_DIRECTION;
}>`
  ${(props) => makeSpace(props.direction, props.token)};
`;

export { Spacer };
